// import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import { Button } from '@forma/forma-ui-kit';
import { useTheme } from '@forma/forma-ui-theme';
import Link from '@/components/Link';
import Logo from '@/components/Logo';
import analytics from '@/helpers/analytics';
import SideMenu from '../SideMenu';
import HeaderMenu from './HeaderMenu';
import Contact from './Contact';

// import { mainCompanyDataAtom } from '@/store/common';

import styles from './header.module.css';

const lkUrl = process.env.LK_URL;
const demoUrl = process.env.DEMO_URL;

const Header = () => {
  const { t } = useTranslation();
  const { lang } = useTheme();
  const { pathname } = useRouter();
  // const { phone } = useAtomValue(mainCompanyDataAtom);

  const showContact = !(pathname.startsWith('/[locale]/templates') || pathname.startsWith('/templates'));

  return (
    <header className={classNames(styles.root, styles.sticky)}>
      <div className={classNames(styles.container, 'container')}>
        <Logo className={styles.logo} />

        <HeaderMenu className={styles.menu} />

        <div className={styles.buttonsPhone}>
          {/* <Button
            as={Link}
            href={phone.href}
            className={styles.buttonPhone}
            viewStyle="text"
            icon={<PhoneIcon />}
          /> */}
          <SideMenu />
        </div>
        <div className={styles.buttons}>
          <Button
            as={Link}
            href={demoUrl}
            className={styles.button}
            viewStyle="secondary"
            size="s"
            onClick={() => {
              analytics.trackYandex('main_demo_header');
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('demo')}
          </Button>
          <Button
            as={Link}
            href={`${lkUrl}/register?lng=${lang}`}
            className={styles.button}
            viewStyle="primary"
            size="s"
            onClick={() => {
              analytics.trackYandex('main_free_start_header');
            }}
          >
            {t('start_free')}
          </Button>
        </div>

        {showContact && <Contact />}
      </div>
    </header>
  );
};

export default Header;
